<div class="mw-nav-list" #navList>
  <ng-template
    *ngFor="let item of items"
    [ngTemplateOutlet]="itemTmpl"
    [ngTemplateOutletContext]="{ item: item }"
  ></ng-template>
</div>

<ng-template #itemTmpl let-item="item">
  <div
    #itemEl
    class="mw-nav-list__item"
    (click)="onItemClick($event, item)"
    [class.mw-nav-list__item--active]="item.isActive"
    [class.mw-nav-list__item--open]="item.isOpened"
    [class.mw-nav-list__item--has-children]="item.hasChildren"
  >
    <div class="mw-nav-list__item-header">
      <mat-icon
        class="mw-nav-list__item-icon"
        *ngIf="item.svgIcon"
        [svgIcon]="item.svgIcon"
      ></mat-icon>
      <mat-icon
        class="mw-nav-list__item-icon"
        [fontSet]="
          item.isOutlineIcon ? 'material-icons-outlined' : 'material-icons'
        "
        *ngIf="item.icon"
      >
        {{ item.icon }}
      </mat-icon>
      <div class="mw-nav-list__item-title text-overflow">
        {{ item.title | translate }}
      </div>
      <mw-arrow-toggler
        *ngIf="item.hasChildren"
        class="mw-nav-list__item-toggle-icon"
        [removeHover]="true"
        [state]="item.isOpened ? 'expanded' : 'collapsed'"
      ></mw-arrow-toggler>
    </div>
    <div
      class="mw-nav-list__item-children"
      [class.collapsed]="!item.isOpened"
      [class.expanded]="item.isOpened"
    >
      <ng-template
        *ngFor="let child of item.children"
        [ngTemplateOutlet]="itemTmpl"
        [ngTemplateOutletContext]="{ item: child }"
      ></ng-template>
    </div>
  </div>
</ng-template>
